<template>
  <a-modal
    title="新建提醒规则"
    :width="1080"
    :visible="visible"
    :confirmLoading="loading"
    @ok="ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="规则名称">
        <a-input
          allow-clear
          :min="1"
          v-decorator="[
            'name',
            {
              rules: [
                { required: true, message: '请输入' },
              ],
            },
          ]"
          placeholder="请输入" />
      </a-form-item>
      <a-form-item label="合同类型">
        <a-select
          allow-clear
          v-decorator="[
            'type',
            {
              rules: [
                { required: true, message: '请选择' },
              ],
            },
          ]"
          placeholder="请选择"
          option-filter-prop="children"
        >
          <a-select-option :key="key" :value="key" v-for="(val, key) in this.dictionaries.trade_sell_contract_type">
            {{ val }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="延期天数">
        <a-input-number
          style="width: 30%"
          v-decorator="[
            'postpone_days',
            {
              rules: [
                { required: true, message: '请选择' }
              ]
            }
          ]"
          placeholder="请输入天数"/>
        <a-select
          v-decorator="[
            'postpone_days_type',
            {
              rules: [
                { required: true, message: '请选择' }
              ]
            }
          ]"
          default-value="1"
          style="width: 20%"
          placeholder="选择">
          <a-select-option value="1">
            天
          </a-select-option>
          <a-select-option value="2">
            工作日
          </a-select-option>
        </a-select>
        <span>(合同创建后延期提醒)</span>
      </a-form-item>
      <a-form-item label="提醒模板">
        <a-select
          @search="this.templateSearch"
          show-search
          allow-clear
          v-decorator="[
            'template_id',
            {
              rules: [
                { required: true, message: '请选择' },
              ],
            },
          ]"
          placeholder="请选择"
          option-filter-prop="children"
        >
          <a-spin v-if="templateFetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="d in templateList" :key="d.id">
            {{ d.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="开启规则">
        <a-switch v-decorator="['is_enabled', { initialValue: false, valuePropName: 'checked' }]" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>

// 表单字段
import debounce from 'lodash/debounce'
import { trade_custom_reminder_template_list } from '@/api/trade_custom_reminder'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },

  data () {
    this.templateSearch = debounce(this.handleTemplateSearch, 800)
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      form: this.$form.createForm(this),
      dictionaries: this.$Dictionaries,
      templateFetching: false,
      templateList: []
    }
  },
  methods: {
    handleTemplateSearch (value) {
      this.templateFetching = true
      trade_custom_reminder_template_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.templateList = result
      }).finally(() => {
        this.templateFetching = false
      })
    },
    ok () {
      this.$emit('ok')
    }
  }
}
</script>
